import { useTranslation } from 'react-i18next';
import { Link, Navigate, useParams } from 'react-router-dom';

import { Markdown } from '../../components/Markdown/Markdown';
import { PageTransition } from '../../components/Transitions/PageTransition';
import { getGuide, isGuideStale } from '../../content/guides';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatDate } from '../../lib/format';

export function GuidePage() {
  const { slug = '' } = useParams();
  const { t } = useTranslation();
  const { language } = useLanguage();
  const guide = getGuide(slug, language);

  if (!guide) return <Navigate to="/guides" replace />;

  const reviewed = formatDate(guide.reviewed, language, { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <PageTransition>
      <article className="mx-auto max-w-3xl px-4 py-10">
        <Link to="/guides" className="text-sm text-brand-primary underline-offset-2 hover:underline">
          {t('guides.back')}
        </Link>

        <div className="mt-6 space-y-3">
          {guide.status === 'draft' && (
            <p role="note" className="rounded-xl border border-status-warning/40 bg-status-warning/10 px-4 py-3 text-sm text-text-secondary">
              {t('guides.draftNotice')}
            </p>
          )}
          {isGuideStale(guide) && (
            <p role="note" className="rounded-xl border border-status-warning/40 bg-status-warning/10 px-4 py-3 text-sm text-text-secondary">
              {t('guides.staleNotice', { date: reviewed })}
            </p>
          )}
        </div>

        <Markdown className="mt-6">{guide.body}</Markdown>

        <footer className="mt-10 border-t border-border pt-4 text-sm text-text-muted">
          {t('guides.maintainedBy', { owner: guide.owner, date: reviewed })}
        </footer>
      </article>
    </PageTransition>
  );
}
